import { API_FRESH_CATEGORY } from 'utils/constants'
import Api from './axiosInstance'

const { CATEGORY } = API_FRESH_CATEGORY

type FetchFreshCategoriesParams = {
  limit: number
  page: number
  search?: string
  // 'true' | 'false' - omitted to list every category
  isActive?: string
}

export type FreshCategoryPayload = {
  name: string
  // Comma-separated - the backend trims, de-dupes and validates each barcode
  excludedBarcodes?: string
  image?: string
  isActive?: boolean
}

const fetchFreshCategories = ({
  limit,
  page,
  search,
  isActive,
}: FetchFreshCategoriesParams) => {
  const options: Record<string, string> = {}
  if (search) options.search = search
  if (isActive === 'true' || isActive === 'false') options.isActive = isActive

  const params = new URLSearchParams({
    limit: String(limit),
    page: String(page),
    ...options,
  })

  return Api.get({ url: `${CATEGORY}?${params}` })
}

const fetchFreshCategory = (id: string) => Api.get({ url: `${CATEGORY}/${id}` })

// What deleting this category would affect -
// { assignedUsers: number, assignedItems: number }
const fetchFreshCategoryUsage = (id: string) =>
  Api.get({ url: `${CATEGORY}/${id}/usage` })

const createFreshCategory = (data: FreshCategoryPayload) =>
  Api.post({ url: CATEGORY, data })

const updateFreshCategory = (id: string, data: FreshCategoryPayload) =>
  Api.patch({ url: `${CATEGORY}/${id}`, data })

const deleteFreshCategory = (id: string) =>
  Api.delete({ url: `${CATEGORY}/${id}` })

export {
  fetchFreshCategories,
  fetchFreshCategory,
  fetchFreshCategoryUsage,
  createFreshCategory,
  updateFreshCategory,
  deleteFreshCategory,
}
